import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";
import backgroundVideo from "../assets/backgroundvideoai.mp4";

function Contact() {
  const form = useRef();
  const [sending, setSending] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true);

    emailjs
      .sendForm(
        "service_6ac3dsr",
        "template_zufa0st",
        form.current,
        "A7utbX4SRk82zqcVD"
      )
      .then(
        () => {
          alert("Thank you for your message! I'll get back to you shortly.");
          form.current.reset();
          setSending(false);
        },
        () => {
          alert("Something went wrong. Please try again.");
          setSending(false);
        }
      );
  };

  return (
    <div className="contact-container">
      <video autoPlay loop muted playsInline className="background-video">
        <source src={backgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="contact-content">
        <h2 className="contact-title">Get in Touch</h2>
        <p className="contact-subtitle">Have a project in mind? I'd love to hear from you.</p>
        <form ref={form} onSubmit={sendEmail}>
          <label htmlFor="name">Name</label>
          <input
            type="text"
            name="name"
            id="name"
            required
            placeholder="Your name"
          />

          <label htmlFor="email">Email</label>
          <input
            type="email"
            name="email"
            id="email"
            required
            placeholder="your@email.com"
          />

          <label htmlFor="message">Message</label>
          <textarea
            name="message"
            id="message"
            rows="4"
            required
            placeholder="Your message..."
          />

          <button type="submit" disabled={sending}>
            {sending ? "Sending..." : "Send"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
